import React from 'react';
import { Outlet } from 'react-router-dom';
import { ShellSidebarProvider } from '@/contexts/ShellSidebarContext';
import { ShellLeftRail } from './ShellLeftRail';
import { ShellMobileBar } from './ShellMobileBar';
import { ShellTabBar } from './ShellTabBar';

export function AppShell() {
  return (
    <ShellSidebarProvider>
      <div className="app-shell h-full flex flex-col min-h-0">
        <ShellMobileBar />
        <ShellTabBar />
        <div className="app-shell-body flex flex-1 min-h-0 min-w-0">
          <ShellLeftRail />
          <div className="app-shell-main flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden lg:overflow-visible">
            <Outlet />
          </div>
        </div>
      </div>
    </ShellSidebarProvider>
  );
}
